import type { FaireProductEntity } from "../../entity_types/product";

export const p_ps8bwv76j6: FaireProductEntity = {
  token: "p_ps8bwv76j6",
  type: "product",
  name: "Smude's Brand Raw Honey - Made from Minnesota Sunflowers",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2e5e0ff950de33b6a668b96d78231c749a205c701ce25a2ec965bd2ecff8cac8.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/60b08354e6e153185059c5727372c6a01449a98b70b947d15b09d9945bd5a340.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
